import { Banner } from "@jsq/ds/core";
import * as styles from "./styles_vanilla.css";

type OwnershipValidationBannerProps = {
  show: boolean;
  message: string;
};

export const OwnershipValidationBanner = ({
  show,
  message,
}: OwnershipValidationBannerProps) => {
  if (!show || !message) return null;

  return (
    <div className={styles.ownershipValidationBannerWrapper}>
      <Banner variant="danger" title={message} role="alert" />
    </div>
  );
};
